import { path } from 'ramda';
import { createSelector } from 'reselect';
import { getCompany, getSelectedCompanyId } from '@twnel/companies-login';

import { NAMESPACE } from '../namespace';

export const selectedCompany = getCompany(getSelectedCompanyId);
export const getSelectedBotspec = (state) => state[NAMESPACE].selectedBotspec;
export const getSelectedVariableGroup = (state) => state[NAMESPACE].selectedVariableGroup;
export const getSelectedStorageGroup = (state) => state[NAMESPACE].selectedStorageGroup;
export const getAllBotspecs = (state) => state[NAMESPACE].botspecs;
export const getAllBotspecsPast = (state) => state[NAMESPACE].past.botspecs;
export const editorError = (state) => state[NAMESPACE].editorError;
export const getLoadingBotspecs = (state) => state[NAMESPACE].loadingBotspecs;
export const isParsing = (state) => state[NAMESPACE].parsing;
export const getBotspecParsingErrors = (state) => state[NAMESPACE].parsingErrors;
export const getFolders = (state) => state[NAMESPACE].folders;
export const getTemplates = (state) => state[NAMESPACE].templates;
export const getChatbotsPublished = (state) => state[NAMESPACE].chatbots;
export const getCurrentBUnits = (state) => state[NAMESPACE].currentBusinessUnits;

export const getBotspecInfo = createSelector(
  (state) => path(['botspecs', 'selectedBotspec'], state),
  (state) => path(['botspecs', 'botspecs'], state),
  (selectedBotspec, botspecs) => (
    { selectedBotspec, botspecs, botspec: botspecs[selectedBotspec] }
  ),
);

export const getBotspec = createSelector(
  getSelectedBotspec,
  getAllBotspecs,
  (selectedBotspec, botspecs) => {
    if (selectedBotspec) {
      return botspecs[selectedBotspec];
    }
    return {};
  },
);

export const getSpecJson = createSelector(
  getBotspec,
  (botspec) => {
    const { spec_json: specJson } = botspec;
    return specJson || {};
  },
);

export const getBotspecVariables = createSelector(
  getSpecJson,
  (specJson) => {
    const { variables } = specJson;
    return variables || {};
  },
);

export const getBotspecFunctions = createSelector(
  getSpecJson,
  (specJson) => {
    const { functions } = specJson;
    return functions || {};
  },
);

export const getBotspecStorage = createSelector(
  getSpecJson,
  (specJson) => {
    const { storage } = specJson;
    return storage || {};
  },
);
